import { ActivityRecord, ArticlePostRequest, ArticleResponse, BackendVersion, SimplePostRequest, SimplePostResponse, UploadUrl } from "type"
import { API_BASE_URL } from "config"
import axios, { AxiosProgressEvent, AxiosResponse } from "axios"

export const fetchArticleById = async (id: number): Promise<ArticleResponse> => {
  const res = await axios.get<ArticleResponse>(API_BASE_URL + '/article/' + id)
  return res.data
}

export const fetchSimplePostById = async (id: number): Promise<SimplePostResponse> => {
  const res = await axios.get<SimplePostResponse>(API_BASE_URL + '/simplepost/' + id)
  return res.data
}

export const fetchActivities = async (): Promise<ActivityRecord[]> => {
  const res = await axios.get<ActivityRecord[]>(API_BASE_URL + '/activity')
  return res.data
}

export const fetchBackendVersion = async (): Promise<BackendVersion> => {
  const res = await axios.get<BackendVersion>(API_BASE_URL + '/info/version')
  return res.data
}

export const callApiForRegisterArticle = async (message: string, filenames: string[]) => {
  const data: ArticlePostRequest = {
    message: message,
    photos: filenames
  }
  return axios.post(API_BASE_URL + '/article', data)
}

export const callApiForRegisterSimplePost = async (filenames: string[]) => {
  const data: SimplePostRequest = {
    photos: filenames
  }
  return axios.post(API_BASE_URL + '/simplepost/add', data)
}

export const issueUploadUrl = async (mediaType: string, authorizationHeaderValue: string): Promise<UploadUrl> => {
  const res = await axios.get<UploadUrl>(API_BASE_URL + '/image/upload-url', {
    params: {
      type: mediaType,
    },
    headers: {
      "Authorization": authorizationHeaderValue
    }
  })

  return res.data
}

export const uploadFile = async (file: File, url: string, contentType: string, onUploadProgress: (event: AxiosProgressEvent) => void): Promise<AxiosResponse> => {
  return await axios.put(url, file, {
    headers: {
      "Content-Type": contentType,
    },
    onUploadProgress: onUploadProgress,
  })
}

export const registerImageRecord = async (filename: string, timestamp: number, mediaType: string) => {
  return await axios.post(API_BASE_URL + '/image', {
    filename: filename,
    timestamp: timestamp,
    type: mediaType
  })
}

export const registerArticlePhotosRecord = async (articleId: number, filenames: string[]) => {
  return await axios.post(API_BASE_URL + '/article/add', {
    id: articleId,
    photos: filenames,
    message: ""
  })
}

export const updateArticleMessage = async (articleId: number, message: string) => {
  return await axios.put(API_BASE_URL + '/article/message', {
    id: articleId,
    message: message,
  })
}